shadow$provide[10] = function(global,require,module,exports) {
module.exports=(ReactDOM);
};